const localizedType = type => {
  let label = '';

  switch (type) {
    case 'App\\Staff':
      label = 'Mitarbeiter';
      break;
    case 'App\\User':
      label = 'Benutzer';
      break;
    case 'App\\Person':
      label = 'Kontakt';
      break;
    case 'App\\Activity':
      label = 'Aktivität';
      break;
    case 'App\\Company':
      label = 'Unternehmen';
      break;
    case 'App\\Project':
      label = 'Projekt';
      break;
    case 'App\\NumberRange':
      label = 'Nummernkreis';
      break;
    case 'App\\ObjectNumber':
      label = 'Nummernkreis - Index';
      break;
    case 'App\\File':
      label = 'Datei';
      break;
    case 'App\\Task':
      label = 'Aufgabe';
      break;
    default:
      label = '';
  }
  return label;
};
export default localizedType;



// WEBPACK FOOTER //
// ./src/helpers/localizedType.js